<template>
  <div class="overflow-y-auto scrolling-touch">
    <slot />
  </div>
</template>
<script>
export default {
  name: 'ViewBody'
};
</script>
